import React from 'react';
import { Modal, Button, Typography, Space, Divider, List } from 'antd';

const { Title, Text } = Typography;

/**
 * Modal component to display changelog entries
 * 
 * @param {boolean} visible - Whether the modal is visible
 * @param {array} changelogs - Array of changelog entries to display
 * @param {function} onClose - Function to call when modal is closed
 */
const ChangelogModal = ({ visible, changelogs = [], onClose }) => {
  if (!changelogs || changelogs.length === 0) return null;

  return (
    <Modal
      title="What's New"
      open={visible}
      footer={[
        <Button key="ok" type="primary" onClick={onClose}>
          Got it!
        </Button>
      ]}
      closable={false}
      maskClosable={false}
      width={600}
      bodyStyle={{ 
        maxHeight: 'calc(80vh - 200px)', 
        overflowY: 'auto', 
        paddingRight: '10px' 
      }}
    >
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        <Text>
          We've made some updates to improve your experience. Here's what's new:
        </Text>
        
        {changelogs.map((changelog, index) => (
          <div key={`changelog-${changelog.version}`}>
            {index > 0 && <Divider />}
            <Title level={5}>
              {changelog.version} - {changelog.date}
            </Title>
            
            <List
              dataSource={changelog.changes}
              renderItem={(change) => (
                <List.Item style={{ padding: '4px 0' }}>
                  <Text>• {change}</Text>
                </List.Item>
              )}
              split={false}
            />
          </div>
        ))}
      </Space>
    </Modal>
  );
};

export default ChangelogModal;
